import React from "react";

export default function Document(props) {
	return (
		//this is large
		<svg xmlns="http://www.w3.org/2000/svg" width="16.834" height="13.774">
			<path
				d="M3.061 7.79v3.06l5.356 2.923 5.356-2.923V7.79l-5.356 2.923ZM8.417 0 0 4.591l8.417 4.591L15.3 5.425v5.288h1.53V4.591Z"
				fill="#32a8a4"
			/>
		</svg>
	);
}

export function DocumentLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="51" height="64">
			<path
				d="M31.875 0h-25.5A6.379 6.379 0 0 0 .032 6.4L0 57.6A6.379 6.379 0 0 0 6.343 64h38.282A6.406 6.406 0 0 0 51 57.6V19.2Zm6.375 51.2h-25.5v-6.4h25.5Zm0-12.8h-25.5V32h25.5Zm-9.562-16V4.8l17.531 17.6Z"
				fill="#2d6fa7"
			/>
		</svg>
	);
}
